import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GTMService } from '../../../shared/gtm.service';
import { MODAL_DATA } from '../../../shared/tokens/modal-data.token';
import { PcReservationTrackEvents } from '../../../shared/types/pc-reservation-track-events.enum';
import { LiveClassService } from '../../live-class.service';
import { PrivateClassBannerCancelPayload } from '../pc-banner-iframe/pc-banner-iframe.component';

export const PC_CANCELLED = 'cancelled';

@Component({
  selector: 'lp2-pc-cancel-modal',
  templateUrl: './pc-cancel-modal.component.html',
  styleUrls: ['./pc-cancel-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PcCancelModalComponent implements OnDestroy {
  isCancelling = false;
  hasError = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(MODAL_DATA) public data: PrivateClassBannerCancelPayload,
    private modal: NgbActiveModal,
    private liveClassService: LiveClassService,
    private gtmService: GTMService,
    private cdr: ChangeDetectorRef
  ) {}

  onConfirm() {
    if (this.isCancelling) {
      return;
    }
    this.isCancelling = true;
    this.hasError = false;
    this.cdr.markForCheck();
    this.gtmService.sendGA4Event(PcReservationTrackEvents.CANCEL_CONFIRMED);

    this.liveClassService
      .cancelReservation(this.data.reservationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.gtmService.sendGA4Event(PcReservationTrackEvents.CANCEL_SUCCESS);
          this.modal.close(PC_CANCELLED);
        },
        () => {
          this.isCancelling = false;
          this.hasError = true;
          this.cdr.markForCheck();
        }
      );
  }

  onDismiss() {
    if (this.isCancelling) {
      return;
    }
    this.gtmService.sendGA4Event(PcReservationTrackEvents.CANCEL_MODAL_DISMISSED);
    this.modal.dismiss();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/pc-cancel-modal/pc-cancel-modal.component.ts